import(/* webpackMode: "eager" */ "/vercel/path0/src/app/docs/page.tsx");
